export function clearState(state) {
  state.menu = false;
  state.mini_menu = false;
  state.panel = null;
  state.filters = null;
  state.messenger = false;
  state.messenger_chat_id = null;
  state.messenger_unread_count = 0;
}
export function setMenu(state, open) {
  state.menu = !!open;
}
export function setMiniMenu(state, mini) {
  state.mini_menu = !!mini;
}
export function toggleMenu(state) {
  state.menu = !state.menu;
}
export function toggleMiniMenu(state) {
  state.mini_menu = !state.mini_menu;
}
export function setFilters(state, open) {
  state.filters = !!open;
}
export function toggleFilters(state) {
  state.filters = !state.filters;
}
export function setPanel(state, open) {
  state.panel = open;
}
export function togglePanel(state, open) {
  state.panel = state.panel === open ? null : open;
}
export function closeAllSidebars(state) {
  state.panel = null;
  state.menu = false;
  state.filters = false;
}
export function openMessenger(state, chatId = null) {
  state.messenger = true;
  if (chatId) {
    state.messenger_chat_id = chatId;
  }
}
export function closeMessenger(state) {
  state.messenger = false;
}
export function setMessengerChatId(state, chatId) {
  state.messenger_chat_id = chatId;
}
export function setMessengerUnreadCount(state, count) {
  state.messenger_unread_count = count;
}
